import store from '~/store'

export default (to, from, next) => {
  var roles = store.getters['auth/roles'];
  if (roles) {
    var roleNames = _.map(roles, (r) => r.name)
    console.log(roleNames,_.includes(roleNames, 'Admin'));
    if (_.includes(roleNames, 'Admin')) {
      return next()
    }
  }
  next({ name: 'welcome' })
}

